import { Box, styled } from "@mui/material";
import { H2, P1 } from "./Typography";

const Section = styled(Box)(() => ({
    backgroundColor: "var(--background-white)",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width: 600px)": {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "12px",
    },
}));

const Title = styled(H2)(() => ({
    color: "var(--text-primary)",
    maxWidth: "400px",
    "@media (max-width: 600px)": {
        fontSize: "32px",
        lineHeight: "39px",
        maxWidth: "100%",
    },
}));

const Description = styled(P1)(() => ({
    color: "var(--text-tertiary)",
    maxWidth: "465px",
    "@media (max-width: 600px)": {
        fontSize: "18px",
        lineHeight: "22px",
        maxWidth: "100%",
    },
}));

interface GuaranteeSectionProps {
    title: string;
    description: string;
}

export const GuaranteeSection = ({ title, description }: GuaranteeSectionProps) => {
    return (
        <Section>
            <Title>{title}</Title>
            <Description>{description}</Description>
        </Section>
    );
};
